import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import React from 'react';

interface CoachingTipProps {
    tip?: string | null;
}

const CoachingTip: React.FC<CoachingTipProps> = ({ tip }) => {
    const theme = useTheme();

    if (tip == null || !String(tip).trim()) {
        return null;
    }

    return (
        <Paper
            elevation={2}
            sx={{
                mt: 3,
                p: 2.5,
                backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 193, 7, 0.1)'
                    : 'rgba(255, 193, 7, 0.15)',
                borderLeft: `4px solid ${theme.palette.warning.main}`,
                borderRadius: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <LightbulbIcon
                    sx={{
                        color: theme.palette.warning.main,
                        fontSize: 28,
                        mt: 0.5,
                        flexShrink: 0
                    }}
                />
                <Box sx={{ flex: 1 }}>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: 'bold',
                            color: theme.palette.warning.main,
                            mb: 1,
                            textTransform: 'uppercase',
                            letterSpacing: 0.5,
                            fontSize: '0.75rem'
                        }}
                    >
                        Coaching Tip
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.primary',
                            lineHeight: 1.6,
                            whiteSpace: 'pre-wrap'
                        }}
                    >
                        {tip}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default CoachingTip;

